const subscriptionStatuses = {
  0: 'Inativo',
  1: 'Ativo',
  2: 'Cancelado',
  3: 'Aguardando cancelamento',
  4: 'Expirado',
  5: 'Aguardando data de início',
}

export default subscriptionStatuses
